import { create } from 'zustand'

interface OfflineTickStore {
  pendingItemIds: Set<string>
  addPending: (itemId: string) => void
  removePending: (itemId: string) => void
  clearAll: () => void
}

export const useOfflineTickStore = create<OfflineTickStore>((set) => ({
  pendingItemIds: new Set(),
  addPending: (itemId) =>
    set((s) => ({ pendingItemIds: new Set(s.pendingItemIds).add(itemId) })),
  removePending: (itemId) =>
    set((s) => {
      const next = new Set(s.pendingItemIds)
      next.delete(itemId)
      return { pendingItemIds: next }
    }),
  clearAll: () => set({ pendingItemIds: new Set() }),
}))
